import React, { useState, useEffect } from "react";
import "./ThemeToggle.css";

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("theme") || "dark";
    const dark = saved !== "light";
    setIsDark(dark);
    document.body.classList.toggle("light-mode", !dark);
  }, []);

  const toggle = () => {
    const next = !isDark;
    setIsDark(next);
    document.body.classList.toggle("light-mode", !next);
    localStorage.setItem("theme", next ? "dark" : "light");
  };

  return (
    <button
      className={`theme-toggle theme-toggle--${isDark ? "dark" : "light"}`}
      onClick={toggle}
      aria-label="Theme wechseln"
      title={isDark ? "light mode" : "dark mode"}
    >
      <span className="theme-toggle__icon">{isDark ? "○" : "●"}</span>
      <span className="theme-toggle__label">{isDark ? "light" : "dark"}</span>
    </button>
  );
};

export default ThemeToggle;
